import { Injectable, Pipe, PipeTransform } from '@angular/core';
import {isNullOrUndefined} from 'util';
export class DualPickListPipe implements PipeTransform {
/**
 * @param {?} items
 * @param {?} field
 * @param {?} value
 * @return {?}
 */
transform(items: any[], field: string, value: any): any[] {
    if (!items)
      return [];

    if(!field)
      return items;

    if(!value || value==='')
      return items;

    if(typeof value === 'boolean')
      return items.filter(it => it[field] == value || isNullOrUndefined(it[field]));
    else
      return items.filter(it =>{
        if(typeof it[field] === 'string')
          return it[field].indexOf(value) > -1;
        else
          return it[field] == value;
      });

  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'searchfilterDualPickList'
}, ] },
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DualPickListPipe_tsickle_Closure_declarations() {
/** @type {?} */
DualPickListPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DualPickListPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
